import { statusIcons } from './statusIcon'

export const events = {
  updateNav: 'UpdateNav',
  removeNav: 'RemoveNav',
  reloadNav: 'ReloadNav',
  kdocsPathChange: 'kdocsPathChange',
  kdocsRefreshMenu: 'kdocsRefreshMenu',
  kdocsRemoveMenu: 'kdocsRemoveMenu',
  kdocsFolderRename: 'kdocsFolderRename',
  kodcsPinToNavbar: 'kodcsPinToNavbar',
  canMove: 'canMove', // 拖动悬浮条
  elementRendered: 'ElementRendered'
}

export const elementIds = {
  addNavBtn: 'button:addNav',
  customPreferenceDropdownOption: 'dropdownOption:customPreference'
}

export const isDev = process.env.NODE_ENV === 'development'

export { statusIcons }
